export interface PremiumStores {
  id: string;
  clubId: string;
  holdId: string;
  galleryId: string;
  storeInfoId: string;
  telephone: string;
  prefecture: string;
  locationName?: string;
  createdDate: Date;
  status: 'A' | 'B';
  storeName: string;
  storeNameEng: string;
  storeNameFurigana: string;
  clubLogo: {
    alt: string;
    description: string;
    path: string;
  };
  gallery: {
    alt: string;
    description: string;
    path: string;
  };
  clubCategory: string;
  profileImage: {
    alt: string;
    description: string;
    path: string;
  };
  coverImage: {
    alt: string;
    description: string;
    path: string;
  };
  groupName: string;
  description: string;
  businessType: string;
  ceoFullName: string;
  ceoFurigana: string;
  companyName: string;
  companyNameFurigana: string;
  companyAddress: string;
  landlineNumber: string;
  mobileNumber: string;
  emailAddress: string;
  username: string;
  identificationType: string;
  passportImage: {
    alt: string;
    description: string;
    path: string;
  };
  insuranceCardImage: {
    alt: string;
    description: string;
    path: string;
  };
  businessCertificateImage: {
    alt: string;
    description: string;
    path: string;
  };
  corporateRegistryImage: {
    alt: string;
    description: string;
    path: string;
  };
  kycFrontImage: {
    alt: string;
    description: string;
    path: string;
  };
  kycBackImage: {
    alt: string;
    description: string;
    path: string;
  };
  holdStatus: 'A' | 'P' | 'B';
  businessLicenseNumber: string;
  licenseIssueDate: number;
  longitude: string;
  latitude: string;
  postalCode: string;
  city: string;
  street: string;
  buildingNo: string;
  workingTimeFrom: string;
  workingTimeTo: string;
  lastEntryTime: string;
  lastOrderTime: string;
  holidays: string;
  tax: string;
  closingDate: string;
  otherHolidays: string[];
  instagram: string;
  tiktok: string;
  line: string;
  twitter: string;
  website: string;
  googleMap: string;
  regularFee: string;
  nominationFee: string;
  companionFee: string;
  extensionFee: string;
  serviceTax: string;
}

export type StatusType = 'A' | 'P' | 'R' | 'approved' | 'pending' | 'rejected';

export enum STORE_STATUS {
  APPROVED = 'A',
  BLOCKED = 'B',
}

export interface ToggleStatusPayload {
  clubId: string;
  status: STORE_STATUS;
}

export interface StoreDeletePayload {
  clubId: string;
}

export interface PremiumStoresListParams {
  row?: number;
  fetch?: number;
  search?: string;
  storeType?: string;
  approvalStatus?: string;
  fromDate?: number;
  toDate?: number;
  status?: string;
  location?: string;
}

export interface GetStoreDetailPayload {
  clubId: string;
  holdId: string;
}

export interface ResetPremiumStorePasswordPayload {
  clubId: string;
}

export interface ManagePremiumStoreInfoPayload {
  profileImage: string | File;
  coverImage: string | File;
  storeName: string;
  storeNameFurigana: string;
  groupName: string;
  description: string;
  businessType: string | number;
  ceoFullName: string;
  ceoFurigana: string;
  companyAddress: string;
  landlineNumber: string;
  mobileNumber: string;
  emailAddress: string;
  username: string;
  identificationType: string;
  passportImage: string;
  insuranceCardImage: string;
  businessCertificateImage: string;
  corporateRegistryImage: string;
  businessLicenseNumber: string;
  licenseIssueDate: number;
  longitude: string;
  latitude: string;
  postalCode: string;
  prefecture: string;
  city: string;
  street: string;
  buildingNo: string;
  workingTimeFrom: string;
  workingTimeTo: string;
  lastEntryTime: string;
  holidays: string;
  tax: string;
  closingDate: string;
  otherHolidays: string[];
  instagram: string;
  tiktok: string;
  line: string;
  twitter: string;
  website: string;
  googleMap: string;
}

export type GetTimeIntervalParams = {
  clubId: string;
};

type TimeIntervalItem = {
  timeInterval: string;
};

export type TimeIntervalList = TimeIntervalItem[];

export type ClubPlanDetailResponse = {
  clubId: string;
  planId: string;
  planTitleJp: string;
  planTitleEng: string;
  planOrigin: 'Club Plan' | 'Admin Plan';
  planTime: string;
  planPrice: number;
  nomination: number;
  lastEntryTime: string;
  noOfPeople: number;
};

export type AdminPlanDetailResponse = {
  clubId: string;
  planId: string;
  planName: string;
  planNameEnglish: string;
  lastEntryTime: string;
  noOfPeople: string;
};

export type AddClubPlanPayload = {
  planTime: string;
  planPrice: number;
  clubId: string;
  lastEntryTime: string;
  noOfPeople: number;
  nomination: number;
};

export type UpdateClubPlanPayload = {
  planId: string;
  clubId: string;
  planTime: string;
  planPrice: number;
  lastEntryTime: string;
  noOfPeople: number;
  nomination: number;
};

export type UpdateAdminPlanPayload = {
  planId: string;
  clubId: string;
  lastEntryTime: string;
  noOfPeople: number;
};

export type UpdateClubPlanStatusPayload = {
  planId: string;
  clubId: string;
  planOrigin: string;
  status: 'A' | 'B' | 'D';
};
